<h3 class="title-divider">{{ heading | translate }}</h3>
<fieldset [disabled]="disabled" capAtLeastOneValidator ngModelGroup="EingabeMussMindestensEinGrundstueckTypAusgewaehltHaben">
  <cap-form-control labelKey="Liegenschaft">
    <input
      (ngModelChange)="model && (model.sucheLig = $event)"
      [disabled]="disabled"
      [ngModel]="model && model.sucheLig"
      name="grunstueckTypAuswahl.sucheLiegebnschaft"
      type="checkbox" />
  </cap-form-control>
  <cap-form-control labelKey="SelbststaendigesUndDauerndesRechtMitAbkuerzung">
    <input
      (ngModelChange)="model && (model.sucheSdr = $event)"
      [disabled]="disabled"
      [ngModel]="model && model.sucheSdr"
      name="grunstueckTypAuswahl.sucheSdr"
      type="checkbox" />
  </cap-form-control>
  <cap-form-control labelKey="Stockwerkeigentum">
    <input
      (ngModelChange)="model && (model.sucheStw = $event)"
      [disabled]="disabled"
      [ngModel]="model && model.sucheStw"
      name="grunstueckTypAuswahl.sucheStockwerkeigentum"
      type="checkbox" />
  </cap-form-control>
  <cap-form-control labelKey="Miteigentumsanteil">
    <input
      (ngModelChange)="model && (model.sucheMit = $event)"
      [disabled]="disabled"
      [ngModel]="model && model.sucheMit"
      name="grunstueckTypAuswahl.sucheMiteigentum"
      type="checkbox" />
  </cap-form-control>
</fieldset>
